import React, { useRef } from "react";

type Props = {
    label: string;
    files: File[];
    onChange: (files: File[]) => void;
    accept?: string;
    multiple?: boolean;
    hint?: string;
    buttonLabel?: string;
    disabled?: boolean;
};

export const FileUploadField: React.FC<Props> = ({
    label,
    files,
    onChange,
    accept,
    multiple = true,
    hint,
    buttonLabel = "Добавить файлы",
    disabled = false,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handlePick = (event: React.ChangeEvent<HTMLInputElement>) => {
        const picked = Array.from(event.target.files ?? []);
        if (picked.length > 0) {
            onChange([...files, ...picked]);
        }
        event.target.value = "";
    };

    const handleRemove = (index: number) => {
        onChange(files.filter((_, currentIndex) => currentIndex !== index));
    };

    return (
        <div className="section-field">
            <div className="section-label">{label}</div>
            {hint ? <div className="section-helper">{hint}</div> : null}
            <div className="section-actions">
                <button
                    type="button"
                    className="section-btn-secondary"
                    disabled={disabled}
                    onClick={() => inputRef.current?.click()}
                >
                    {buttonLabel}
                </button>
            </div>
            <input
                ref={inputRef}
                type="file"
                style={{ display: "none" }}
                multiple={multiple}
                accept={accept}
                disabled={disabled}
                onChange={handlePick}
            />
            {files.length > 0 ? (
                <div className="section-upload-list">
                    {files.map((file, index) => (
                        <div className="section-upload-row" key={`${file.name}-${index}`}>
                            <div className="section-upload-name">{file.name}</div>
                            <button
                                type="button"
                                className="section-upload-remove"
                                disabled={disabled}
                                onClick={() => handleRemove(index)}
                            >
                                Удалить
                            </button>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};
